"use client";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import heroAnimationDesktop from "@/lottie/hero-desktop.json";
import heroAnimationMobile from "@/lottie/mobile-hero.json";
import { Headline6 } from "@/components/typography";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

export function HeroSection() {
  const { isAuthenticated, openConnectModal } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <section className="relative w-full h-[100svh] flex items-center justify-center overflow-hidden bg-background">
      {/* Background Lottie Animation */}
      <div className="absolute inset-0 overflow-hidden flex items-center justify-center">
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            scale: "1.5",
          }}
        >
          <Lottie
            animationData={
              isMobile ? heroAnimationMobile : heroAnimationDesktop
            }
            loop
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        {/* Title */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-medium tracking-[-1.5px] text-spicenet-black mb-4">
          Spicenet Portal
        </h1>

        {/* Subtitle */}
        <Headline6 className=" uppercase text-muted-dark mb-8 font-mono">
          Play, earn, and be part of the first brokerage network for DeFi
        </Headline6>

        {/* CTA Button */}
        {!isAuthenticated && (
          <Button variant="primary" size="lg" onClick={openConnectModal}>
            Log In
          </Button>
        )}
      </div>
    </section>
  );
}
